export const SUCCESS_STATUS = 1;
export const ERROR_STATUS = 0;
export const QUERY_METHODS = {
    POST: 'POST',
};
